import { useSpotlightedBadge } from '../useSpotlightedBadge/useSpotlightedBadge'
import { useAlumniBadge } from '../useAlumniBadge/useAlumniBadge'

export const useOrganisationBadge = (organisationId?: string | null) => {
  const { spotlightedBadge, spotlightedBadgeTooltip } = useSpotlightedBadge(organisationId)
  const { alumniBadge, alumniBadgeTooltip } = useAlumniBadge(organisationId)

  if (spotlightedBadge) {
    return { badge: spotlightedBadge, badgeTooltip: spotlightedBadgeTooltip }
  }

  if (alumniBadge) {
    return { badge: alumniBadge, badgeTooltip: alumniBadgeTooltip }
  }

  return { badge: null, badgeTooltip: null }
}
